import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import type { FormField } from '../../../../models/built-form';

// TODO: implement config UI
@Component({
  selector: 'app-rich-text-config-view',
  standalone: true,
  templateUrl: './rich-text-config-view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RichTextConfigViewComponent {
  readonly field = input.required<FormField>();
  readonly fieldChange = output<FormField>();
}
